var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isModal
    ? _c(
        "modal",
        {
          attrs: {
            printButton: "",
            downloadButton: "",
            close: _vm.close,
            printStyle: _vm.style,
            title: "Онлайн-проверка адреса",
            pdfFileName: "CheckAddress_" + _vm.address,
          },
        },
        [
          _c("h3", { attrs: { slot: "modalHeader" }, slot: "modalHeader" }, [
            _c("b", [_vm._v("Онлайн-проверка адреса")]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "content",
              attrs: { slot: "modalBody" },
              slot: "modalBody",
            },
            [
              _c("addressCheckPDF", {
                attrs: {
                  data: _vm.data_result,
                  date: _vm.date,
                  address: _vm.address,
                },
              }),
            ],
            1
          ),
        ]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }